
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import ColorScaleCompService from '@/services/ColorScaleComp.service';
import ColorScalesHeader from "@/components/ColorScalesHeader.vue";

const namespace = "ColorConversionModule";

@Component({
  components: {
    ColorScalesHeader,
  },
  metaInfo: {
    title: 'Color Conversion',
    titleTemplate: 'Conversion'
  }
})

export default class ColorConversion extends Vue{
  @Mutation('setSliderHue', {namespace}) private setSliderHue!: (value:number) => any;
  @Mutation('setSliderR', {namespace}) private setSliderR!: (value:number) => any;
  @Mutation('setSliderG', {namespace}) private setSliderG!: (value:number) => any;
  @Mutation('setSliderB', {namespace}) private setSliderB!: (value:number) => any;
  @Mutation('setSliderLuminance', {namespace}) private setSliderLuminance!: (value:number) => any;
  @State('sliderHue', { namespace }) private sliderHue!: number;
  @State('sliderR', { namespace }) private sliderR!: number;
  @State('sliderG', { namespace }) private sliderG!: number;
  @State('sliderB', { namespace }) private sliderB!: number;
  @State('sliderLuminance', { namespace }) private sliderLuminance!:  number;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }

  private handleHueSlider(event:any){
    this.setSliderHue(parseInt(event.target.value));
  }

  private handleRSlider(event:any){
    this.setSliderR(parseInt(event.target.value));
  }

  private handleGSlider(event:any){
    this.setSliderG(parseInt(event.target.value));
  }

  private handleBSlider(event:any){
    this.setSliderB(parseInt(event.target.value));
  }

  private handleLuminanceSlider(event:any){
    this.setSliderLuminance(event.target.value);
  }

  // ------------------------

  private HLtoLUV() : number[] {
    return ColorScaleCompService.HLtoLUV(this.sliderHue, this.sliderLuminance);
  }

  private HLtoXYZ() : number[] {
    return ColorScaleCompService.HLtoXYZ(this.sliderHue, this.sliderLuminance);
  }

  private HLtoRGB() : number[] {
    return ColorScaleCompService.HLtoRGB(this.sliderHue, this.sliderLuminance);
  }

  private HLtoHEX() : string {
    return ColorScaleCompService.HLtoHEX(this.sliderHue, this.sliderLuminance);
  }

  // -----------------------------

  private RGBtoXYZ() : number[] {
    return ColorScaleCompService.RGBtoXYZ(this.sliderR, this.sliderG, this.sliderB);
  }

  private RGBtoLUV() : number[] {
    return ColorScaleCompService.RGBtoLUV(this.sliderR, this.sliderG, this.sliderB);
  }

  private RGBtoHL() : number[] {
    return ColorScaleCompService.RGBtoHL(this.sliderR, this.sliderG, this.sliderB);
  }

  // -------------------------------

  private RGBtoNote() : string {
    return ColorScaleCompService.RGBtoNote(this.sliderR, this.sliderG, this.sliderB);
  }
  
};
